package com.devi3east.bashbuddy.di

import com.devi3east.bashbuddy.auth.capability.AuthCapability
import com.devi3east.bashbuddy.cart.storage.CartStorage
import com.devi3east.bashbuddy.common.service.AppVersionProvider
import com.devi3east.bashbuddy.common.service.VersionCheckService
import com.devi3east.bashbuddy.common.service.appVersionProvider
import com.devi3east.bashbuddy.features.ticketing.TicketingCapability
import org.koin.dsl.module

expect fun ticketingCapability(): TicketingCapability
expect fun authCapability(): AuthCapability
expect fun cartStorage(): CartStorage

fun platformModule() = module {
    single<TicketingCapability> { ticketingCapability() }
    single<AuthCapability> { authCapability() }
    single<CartStorage> { cartStorage() }

    single<AppVersionProvider> {
        appVersionProvider()
    }

    single {
        VersionCheckService(
            appVersionProvider = get()
        )
    }
}
